import React, { useEffect } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import Login from '../components/Login/Login'
import useAuthStore from '../stores/authStore'

const LoginPage = () => {
  const navigate = useNavigate()
  const { 
    isAuthenticated, 
    login, 
    signUp, 
    confirmSignUp, 
    resendConfirmationCode,
    checkAuthStatus,
    isLoading,
    error,
    clearError
  } = useAuthStore()

  // Check auth status on mount
  useEffect(() => {
    checkAuthStatus()
  }, [checkAuthStatus])

  // Clear error when component unmounts
  useEffect(() => {
    return () => {
      clearError()
    }
  }, [clearError])

  // If already authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/home" replace />
  }

  const handleSignIn = async (username, password) => {
    const result = await login(username, password)
    
    if (result.success) {
      // Redirect to home after successful login
      navigate('/home', { replace: true })
    }
    
    return result
  }

  const handleSignUp = async (username, password, email, firstName, lastName) => {
    const result = await signUp(username, password, email, firstName, lastName)
    return result
  }

  const handleConfirmSignUp = async (username, confirmationCode) => {
    const result = await confirmSignUp(username, confirmationCode)
    // Success message is handled in Login component after mode switch
    return result
  }

  const handleResendCode = async (username) => {
    const result = await resendConfirmationCode(username)
    return result
  }

  return (
    <Login
      onSignIn={handleSignIn}
      onSignUp={handleSignUp}
      onConfirmSignUp={handleConfirmSignUp}
      onResendCode={handleResendCode}
      isLoading={isLoading}
      error={error}
    />
  )
}

export default LoginPage

